import React from 'react'

import { getBindingLabel } from '../../../../utils/bindings'

import styles from './Steps.module.css'

export default function Property({ label, children, action, value }) {
  if (value) {
    if (value.__array) {
      const length = value.__array.length

      children = `${length} item${length === 1 ? '' : 's'}`
    } else if (typeof value === 'string') {
      children = value
    } else if (Array.isArray(value)) {
      children = value.map((itm, i) =>
        typeof itm === 'string' ? (
          // eslint-disable-next-line react/no-array-index-key
          <span key={i}>{itm}</span>
        ) : (
          <Chip key={itm.id}>{getBindingLabel(itm, action)}</Chip>
        )
      )
    }
  }

  return (
    <div className={styles.property}>
      <h5 className={styles.propertyLabel}>{label}</h5>
      <div className={styles.propertyValue}>{children}</div>
    </div>
  )
}

const Chip = function PropertyChip({ children }) {
  return <span className={styles.chip}>{children}</span>
}
